import { Col, Form, Row } from "antd";

import React from "react";
import styled from "styled-components";
import Explain from "../../../../components/atoms/Explain";
import RadioGroup from "../../../../components/atoms/RadioGroup";
import Table from "../../../../components/atoms/Table";
import TimePicker from "../../../../components/atoms/TimePicker";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import sharedConstants from "../../../../shared/constants";
import { BusinessDayType } from "../../../../shared/enums";

import { businessDayTypeArray } from "../../../../shared/options";
import { theme } from "../../../../theme";
import { getWeekendWeekDayColumns, getAlldayColumns } from "../../constants";
import { RenderInputProps, ReservationTime } from "../../Interface";
import { CustomTd, Wave } from "../../styles";
import { stringTimeToMoment } from "../../utils";

import PlusButtonRow from "../PlusButtonRow";

const { Item } = Form;

const ReservationTimeInputs: React.FC<RenderInputProps> = ({ form }) => {
  const businessDayTypes = Form.useWatch("businessDayTypes", form);
  const weekdayWeekendTimeArray = Form.useWatch(
    "weekdayWeekendTimeArray",
    form
  );
  const alldayTimeArray = Form.useWatch("alldayTimeArray", form);
  const startTime = Form.useWatch("startTime", form);
  const endTime = Form.useWatch("endTime", form);

  const renderInput = (type: BusinessDayType) => {
    switch (type) {
      case BusinessDayType.EVERYDAY:
        return (
          <ExplainWrapper
            status={{
              status:
                startTime === undefined ||
                startTime?.length === 0 ||
                endTime === undefined ||
                endTime?.length === 0 ||
                stringTimeToMoment(startTime)?.isSameOrAfter(
                  stringTimeToMoment(endTime)
                )
                  ? "error"
                  : undefined,
              explain:
                startTime === undefined ||
                startTime?.length === 0 ||
                endTime === undefined ||
                endTime?.length === 0
                  ? sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                  : stringTimeToMoment(startTime)?.isSameOrAfter(
                      stringTimeToMoment(endTime)
                    )
                  ? sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME
                  : undefined,
            }}
          >
            <StyledRow gutter={[12, 0]}>
              <Col flex="0 0 200px">
                <TimePicker
                  value={startTime}
                  popupStyle={{
                    minWidth: "calc(200px - 32px)",
                  }}
                  onOk={(selectedTime) => {
                    form.setFieldsValue({
                      startTime: selectedTime,
                    });
                  }}
                  // disabledTime={() =>
                  //   makeDisableStartTime({
                  //     startTime,
                  //     endTime,
                  //   })
                  // }
                  status={
                    startTime === undefined ||
                    startTime?.length === 0 ||
                    endTime === undefined ||
                    endTime?.length === 0 ||
                    stringTimeToMoment(startTime)?.isSameOrAfter(
                      stringTimeToMoment(endTime)
                    )
                      ? "error"
                      : undefined
                  }
                  // endHour={endTime?.hours()}
                  // type={TimeMode.START}
                />
              </Col>
              <Wave />
              <Col flex="0 0 200px">
                <TimePicker
                  popupStyle={{
                    minWidth: "calc(200px - 32px)",
                  }}
                  value={endTime}
                  onOk={(selectedTime) => {
                    form.setFieldsValue({
                      endTime: selectedTime,
                    });
                  }}
                  // disabledTime={() =>
                  //   makeDisableEndTime({
                  //     endTime,
                  //     startTime,
                  //   })
                  // }
                  status={
                    startTime === undefined ||
                    startTime?.length === 0 ||
                    endTime === undefined ||
                    endTime?.length === 0 ||
                    stringTimeToMoment(startTime)?.isSameOrAfter(
                      stringTimeToMoment(endTime)
                    )
                      ? "error"
                      : undefined
                  }
                  // startHour={startTime?.hours()}
                  // type={TimeMode.END}
                />
              </Col>
            </StyledRow>
          </ExplainWrapper>
        );
      case BusinessDayType.WEEKDAY_WEEKEND:
        return (
          <>
            <Table
              size="large"
              columns={getWeekendWeekDayColumns(form)}
              dataSource={weekdayWeekendTimeArray}
              pagination={false}
              components={{
                body: {
                  cell: (props: any) => <CustomTd>{props.children}</CustomTd>,
                },
              }}
              style={{ flex: "1 1 1" }}
              rowKey="days"
            />
          </>
        );
      case BusinessDayType.DAY: {
        const disabledCheckboxValue = (
          form.getFieldValue("alldayTimeArray") as ReservationTime[]
        ).reduce((pre: string[], cur: ReservationTime) => {
          if (cur.days)
            for (let i = 0; i < cur?.days?.length; i += 1) {
              if (!pre.includes(cur.days[i])) pre.push(cur.days[i]);
            }

          return pre;
        }, []);
        return (
          <StyledRow>
            <Table
              size="large"
              columns={getAlldayColumns(form)}
              dataSource={alldayTimeArray?.map((val: any, index: number) => ({
                id: index,
                ...val,
              }))}
              pagination={false}
              components={{
                body: {
                  cell: (props: any) => <CustomTd>{props.children}</CustomTd>,
                },
              }}
              rowKey="id"
            />
            <PlusButtonRow
              disabled={
                disabledCheckboxValue?.length === 7 ||
                alldayTimeArray?.filter(
                  (val: ReservationTime) => val.days?.length === 0
                ).length > 0
              }
              onClick={() => {
                form.setFieldsValue({
                  alldayTimeArray: [
                    ...alldayTimeArray,
                    {
                      days: [],
                      startTime: undefined,
                      endTime: undefined,
                    },
                  ],
                });
              }}
            />
          </StyledRow>
        );
      }
      default:
        return null;
    }
  };
  return (
    <Row gutter={[0, 12]}>
      <Col span={24}>
        <Explain
          color={theme.colors.gray3}
          status="question"
          explain="휴게시간이 있는 경우 ‘휴게시간’ 항목에서 입력해주세요."
        />
      </Col>
      <Col span={24}>
        <Item
          noStyle
          name="startTime"
          validateTrigger="onChange"
          rules={[
            {
              validator: async (_, startTime?: string) => {
                if (businessDayTypes === BusinessDayType.EVERYDAY)
                  if (startTime === undefined || startTime?.length === 0)
                    return Promise.reject(
                      new Error(
                        sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                      )
                    );
                if (
                  stringTimeToMoment(startTime)?.isSameOrAfter(
                    stringTimeToMoment(endTime)
                  )
                )
                  return Promise.reject(
                    new Error(
                      sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME
                    )
                  );
                return Promise.resolve();
              },
            },
          ]}
        />
        <Item
          noStyle
          name="endTime"
          validateTrigger="onChange"
          rules={[
            {
              validator: async (_, endTime?: string) => {
                if (businessDayTypes === BusinessDayType.EVERYDAY)
                  if (endTime === undefined || endTime?.length === 0)
                    return Promise.reject(
                      new Error(
                        sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                      )
                    );
                if (
                  stringTimeToMoment(startTime)?.isSameOrAfter(
                    stringTimeToMoment(endTime)
                  )
                )
                  return Promise.reject(
                    new Error(
                      sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME
                    )
                  );
                return Promise.resolve();
              },
            },
          ]}
        />
        <Item noStyle name="weekdayWeekendTimeArray" />
        <Item noStyle name="alldayTimeArray" />
        <Item noStyle name="businessDayTypes">
          <RadioGroup options={businessDayTypeArray} />
        </Item>
      </Col>

      <Col span={24}>{renderInput(businessDayTypes)}</Col>
    </Row>
  );
};

const StyledRow = styled(Row)`
  flex: 0 0 432px;
`;
export default ReservationTimeInputs;
